import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Radio, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";

const { TextArea } = Input;

const AddStaffStatusModal = ({
  open,
  handleCancel,
  handleFetchData,
  prodd,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);
  const [data, setData] = useState({});

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const [value, setValue] = useState(prodd?.ssActive ? prodd?.ssActive : "on" );
 
  const onChangeRadio = (e) => {
    setValue(e.target.value);
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        ssId: prodd?.ssId ? prodd?.ssId : null,
        ssStatuscode: formData?.ssStatuscode,
        ssStatusname: formData?.ssStatusname,
        ssActive: value,
        url: "hr/saveStaffStatus.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  useEffect(() => {
    setValue(prodd?.ssActive ? prodd?.ssActive : "on" );
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit staff status ${prodd?.ssStatusname}`
            : "Add staff status details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            label="Status Code"
            rules={[
              {
                required: true,
                message: "Enter Status Code",
              },
            ]}
          >
            <Input
              readOnly={prodd?.ssId ? true : false}
              required
              name="ssStatuscode"
              onChange={onChange}
              value={formData?.ssStatuscode}
              className="input"
            />
          </Form.Item>
          <Form.Item
            label="Status Name"
            rules={[
              {
                required: true,
                message: "Enter Status name",
              },
            ]}
          >
            <Input
              required
              name="ssStatusname"
              onChange={onChange}
              value={formData?.ssStatusname}
              className="input"
            />
          </Form.Item>

          <Form.Item>
            <Radio.Group onChange={onChangeRadio} value={value}>
              <Radio value={"on"}>Active</Radio>
              <Radio value={""}>Inactive</Radio>
            </Radio.Group>
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddStaffStatusModal;
